import React from 'react';
import { motion } from 'framer-motion';
const Resume = () => {
  return <div className="container mx-auto px-4 py-12 max-w-4xl bg-white" data-id="element-419">
      <div className="mb-8 flex justify-between items-center" data-id="element-420">
        <h1 className="text-4xl font-bold" data-id="element-421">John Doe</h1>
        <button onClick={() => window.print()} className="px-4 py-2 bg-[#0FB9B1] text-white rounded-md" data-id="element-422">
          Print / Save as PDF
        </button>
      </div>
      <div className="mb-6" data-id="element-423">
        <p className="text-gray-700" data-id="element-424">123 Main Street, City, State 12345</p>
        <p className="text-gray-700" data-id="element-425">johndoe@example.com | (123) 456-7890</p>
      </div>
      <div className="mb-8" data-id="element-426">
        <h2 className="text-2xl font-bold border-b-2 border-gray-300 pb-2 mb-4" data-id="element-427">
          Professional Summary
        </h2>
        <p className="text-gray-800" data-id="element-428">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
      </div>
      <div className="mb-8" data-id="element-429">
        <h2 className="text-2xl font-bold border-b-2 border-gray-300 pb-2 mb-4" data-id="element-430">
          Experience
        </h2>
        <div className="mb-6" data-id="element-431">
          <h3 className="text-xl font-semibold" data-id="element-432">Senior Product Manager</h3>
          <div className="flex justify-between" data-id="element-433">
            <p className="font-medium" data-id="element-434">Lorem Company Inc.</p>
            <p className="text-gray-600" data-id="element-435">January 2020 - Present</p>
          </div>
          <ul className="list-disc ml-5 mt-2" data-id="element-436">
            <li data-id="element-437">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li data-id="element-438">
              Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </li>
            <li data-id="element-439">Ut enim ad minim veniam, quis nostrud exercitation ullamco.</li>
            <li data-id="element-440">
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum.
            </li>
          </ul>
        </div>
        <div className="mb-6" data-id="element-441">
          <h3 className="text-xl font-semibold" data-id="element-442">Product Manager</h3>
          <div className="flex justify-between" data-id="element-443">
            <p className="font-medium" data-id="element-444">Ipsum Technologies</p>
            <p className="text-gray-600" data-id="element-445">June 2017 - December 2019</p>
          </div>
          <ul className="list-disc ml-5 mt-2" data-id="element-446">
            <li data-id="element-447">Excepteur sint occaecat cupidatat non proident.</li>
            <li data-id="element-448">
              Sunt in culpa qui officia deserunt mollit anim id est laborum.
            </li>
            <li data-id="element-449">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
          </ul>
        </div>
      </div>
      <div className="mb-8" data-id="element-450">
        <h2 className="text-2xl font-bold border-b-2 border-gray-300 pb-2 mb-4" data-id="element-451">
          Education
        </h2>
        <div className="mb-4" data-id="element-452">
          <h3 className="text-xl font-semibold" data-id="element-453">
            Master of Business Administration
          </h3>
          <div className="flex justify-between" data-id="element-454">
            <p className="font-medium" data-id="element-455">University of Lorem Ipsum</p>
            <p className="text-gray-600" data-id="element-456">2015 - 2017</p>
          </div>
        </div>
        <div className="mb-4" data-id="element-457">
          <h3 className="text-xl font-semibold" data-id="element-458">
            Bachelor of Science in Computer Science
          </h3>
          <div className="flex justify-between" data-id="element-459">
            <p className="font-medium" data-id="element-460">Dolor Sit University</p>
            <p className="text-gray-600" data-id="element-461">2011 - 2015</p>
          </div>
        </div>
      </div>
      <div className="mb-8" data-id="element-462">
        <h2 className="text-2xl font-bold border-b-2 border-gray-300 pb-2 mb-4" data-id="element-463">
          Skills
        </h2>
        <div className="grid grid-cols-2 gap-4" data-id="element-464">
          <ul className="list-disc ml-5" data-id="element-465">
            <li data-id="element-466">Lorem ipsum dolor sit amet</li>
            <li data-id="element-467">Consectetur adipiscing elit</li>
            <li data-id="element-468">Sed do eiusmod tempor</li>
            <li data-id="element-469">Ut enim ad minim veniam</li>
          </ul>
          <ul className="list-disc ml-5" data-id="element-470">
            <li data-id="element-471">Quis nostrud exercitation</li>
            <li data-id="element-472">Ullamco laboris nisi</li>
            <li data-id="element-473">Duis aute irure dolor</li>
            <li data-id="element-474">Excepteur sint occaecat</li>
          </ul>
        </div>
      </div>
    </div>;
};
export default Resume;